import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';

const Erro404 = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Desculpe, a página que você está procurando não existe."
      extra={
        <Button type="primary" onClick={() => navigate('/inicio')}>
          Voltar
        </Button>
      }
    />
  );
};

export default Erro404;